(() => {
  const showMoreBtn = document.querySelector(".js-show-more");
  const content = document.querySelector(".js-content");

  const checkContentHeight = () => {
    const isMobile = window.innerWidth < 750;
    const heightLimit = isMobile ? 72 : 81;

    if (content.offsetHeight > heightLimit) {
      content.classList.add("truncate");
      showMoreBtn.style.display = "block";
    } else {
      showMoreBtn.style.display = "none";
    }
  };

  checkContentHeight();

  showMoreBtn.addEventListener("click", () => {
    const isTruncated = content.classList.toggle("truncate");
    showMoreBtn.textContent = isTruncated ? "mehr lesen" : "weniger lesen";
  });
})();
